var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._t("default"),_c('v-progress-circular',{staticClass:"ml-4",attrs:{"size":"24","color":"secondary","indeterminate":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }